import { constantRouterMap } from '@/router/index'
import Layout from '../../views/menu/Layout'
const _import = require('../../router/_import_' + process.env.NODE_ENV)
let optionChild = null
let option = null
let accessedRouters = []

const permission = {
  state: {
    menu: [],
    routers: constantRouterMap, // 本用户所有的路由,包括了固定的路由和下面的addRouters
    addRouters: [] // 本用户的角色赋予的新增的动态路由
  },
  mutations: {
    SET_Menu: (state, routers) => {
      state.menu = routers
      console.log('菜单', state.menu)
    },
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers) // 将固定路由和新增路由进行合并, 成为本用户最终的全部路由信息
    }
  },
  actions: {
    GenerateRoutes({ commit }, userMenuTree) {
      // 生成路由
      return new Promise(resolve => {
        // 此处每次改变菜单都需要来维护，修改对应的逻辑
        // （不修改代码的情况下菜单改变只支持菜单禁用和菜单从当前目录调整到同级的目录中，不可调整到其他的菜单下，会导致菜单不可用）
        // userMenuTree是后台传过来的菜单树，在这里转化为前端用的路由
        const menus = userMenuTree
        menus.forEach((item, index) => {
          switchCaseMenuDirectory(item)
        })
        let menu = JSON.parse(JSON.stringify(accessedRouters))
        commit('SET_Menu', menu)
        accessedRouters = delteFakeParent(accessedRouters)
        // 执行设置路由的方法
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    }
  }
}
function switchCaseMenuDirectory(item) {
  switch (item.funCode) {
    // 这里设置菜单目录，格式不同
    case 'home': // 单页设置
      option = {
        id: item.id,
        parentId: item.parentId,
        path: '/',
        redirect: '/home',
        component: Layout,
        menu: 'home',
        children: [
          {
            path: 'home',
            component: () => import('@/views/home/index'),
            name: 'Home',
            meta: { title: '密码计算', icon: 'home', noCache: true }
          }
        ]
      }
      pushMenu(item, option)
      break
    case 'notice': // 单页设置
      option = {
        id: item.id,
        parentId: item.parentId,
        path: '/',
        redirect: '/notice',
        component: Layout,
        menu: 'notice',
        children: [
          {
            path: 'notice',
            component: () => import('@/views/exam/notice'),
            name: 'Notice',
            meta: { title: '公告', icon: 'notice', noCache: true }
          }
        ]
      }
      pushMenu(item, option)
      break
    case 'notice_detail': // 单页设置
      option = {
        id: item.id,
        parentId: item.parentId,
        path: '/',
        redirect: '/notice_detail',
        component: Layout,
        menu: 'notice_detail',
        hidden: true,
        children: [
          {
            path: 'notice_detail',
            component: () => import('@/views/exam/notice_detail'),
            name: 'NoticeDetail',
            meta: { title: '公告详情', icon: 'notice_detail', noCache: true }
          }
        ]
      }
      pushMenu(item, option)
      break
    case 'device': // 单页设置
      option = {
        id: item.id,
        parentId: item.parentId,
        path: '/',
        component: Layout,
        menu: 'device',
        children: [
          {
            path: 'device',
            component: () => import('@/views/device/index'),
            name: 'Device',
            meta: { title: '设备信息', icon: 'device', noCache: true }
          }
        ]
      }
      pushMenu(item, option)
      break
    case 'distributor': // 单页设置
      option = {
        id: item.id,
        parentId: item.parentId,
        path: '/',
        component: Layout,
        menu: 'distributor',
        children: [
          {
            path: 'distributor',
            component: () => import('@/views/distributor/index'),
            name: 'Distributor',
            meta: { title: '经销商信息', icon: 'distributor', noCache: true }
          }
        ]
      }
      pushMenu(item, option)
      break
    case 'distributor_device_admin': // 单页设置
      option = {
        id: item.id,
        parentId: item.parentId,
        path: '/',
        component: Layout,
        menu: 'distributor_device_admin',
        children: [
          {
            path: 'distributor_device_admin',
            component: () => import('@/views/distributor_device_admin/index'),
            name: 'DistributorDeviceAdmin',
            meta: { title: '经销商-设备关联', icon: 'distributor_device', noCache: true }
          }
        ]
      }
      pushMenu(item, option)
      break
    case 'distributor_device': // 单页设置
      option = {
        id: item.id,
        parentId: item.parentId,
        path: '/',
        component: Layout,
        menu: 'distributor_device',
        children: [
          {
            path: 'distributor_device',
            component: () => import('@/views/distributor_device/index'),
            name: 'DistributorDevice',
            meta: { title: '设备关联', icon: 'distributor_device', noCache: true }
          }
        ]
      }
      pushMenu(item, option)
      break
    case 'distributor_user': // 单页设置
      option = {
        id: item.id,
        parentId: item.parentId,
        path: '/',
        component: Layout,
        menu: 'distributor_user',
        children: [
          {
            path: 'distributor_user',
            component: () => import('@/views/distributor_user/index'),
            name: 'DistributorDevice',
            meta: { title: '经销商-账号关联', icon: 'distributor_user', noCache: true }
          }
        ]
      }
      pushMenu(item, option)
      break
    case 'sys_dictionary': // 单页设置
      option = {
        id: item.id,
        parentId: item.parentId,
        path: '/',
        component: Layout,
        menu: 'sys_dictionary',
        children: [
          {
            path: 'sys_dictionary',
            component: () => import('@/views/sys_dictionary/index'),
            name: 'DistributorDevice',
            meta: { title: '系统字典', icon: 'sys_dictionary', noCache: true }
          }
        ]
      }
      pushMenu(item, option)
      break
    case 'identifier_record': // 单页设置
      option = {
        id: item.id,
        parentId: item.parentId,
        path: '/',
        component: Layout,
        menu: 'identifier_record',
        children: [
          {
            path: 'identifier_record',
            component: () => import('@/views/identifier_record/index'),
            name: 'IdentifierRecord',
            meta: { title: '算号记录', icon: 'identifier_record', noCache: true }
          }
        ]
      }
      pushMenu(item, option)
      break
    case 'exam_training':
      option = { // 一级父级
        id: item.id,
        parentId: item.parentId,
        path: '/exam_training',
        component: Layout,
        redirect: '/exam_training/',
        meta: { title: '考试培训', icon: 'exam_training' },
        children: []
      }
      pushMenu(item, option)
      break
    case 'system_management':
      option = { // 一级父级
        id: item.id,
        parentId: item.parentId,
        path: '/system_management',
        component: Layout,
        redirect: '/system_management/',
        meta: { title: '系统管理', icon: 'system_management' },
        children: []
      }
      pushMenu(item, option)
      break
    case 'file_download': // 单页设置
      option = {
        id: item.id,
        parentId: item.parentId,
        path: '/',
        component: Layout,
        menu: 'file_download',
        children: [
          {
            path: 'file_download',
            component: () => import('@/views/file_download/index'),
            name: 'IdentifierRecord',
            meta: { title: '技术文档资料库', icon: 'file_download', noCache: true }
          }
        ]
      }
      pushMenu(item, option)
      break
    case 'user_permissions':
      option = { // 一级父级
        id: item.id,
        parentId: item.parentId,
        path: '/user_permissions',
        component: Layout,
        redirect: '/user_permissions/',
        meta: { title: '账户管理', icon: 'user_permissions' },
        children: []
      }
      pushMenu(item, option)
      break
    case 'question_bank_management':
      option = { // 一级父级
        id: item.id,
        parentId: item.parentId,
        path: '/question_bank_management',
        component: Layout,
        redirect: '/question_bank_management/',
        meta: { title: '题库管理', icon: 'question_bank_management' },
        children: []
      }
      pushMenu(item, option)
      break
  }
}
function pushMenu(item, option) {
  if (item.children.length > 0) {
    item.children.forEach(val => {
      if (val.children.length === 0) {
        // 这里设置菜单
        switchCaseMenu(val.funCode)
        option.children.push(optionChild)
      } else {
        accessedRouters.push(option)
        switchCaseMenuDirectory(val)
      }
    })
  }
  if (option.parentId === null) {
    if (accessedRouters.indexOf(option) === -1) {
      accessedRouters.push(option)
    }
  } else {
    accessedRouters.forEach((j) => {
      if (j.id === item.parentId) {
        j.children.push(option)
      }
    })
  }
}
function switchCaseMenu(item) {
  let option = null
  switch (item) { // 子级
    // 设置菜单
    case 'staff_permission':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'staff_permission',
        name: 'StaffPermission',
        meta: { title: '员工权限', icon: 'staff_permission', noCache: false },
        component: _import('user_permissions/staff_permission'),
        menu: 'user'
      }
      optionChild = option
      break
    case 'user':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'user',
        name: 'User',
        meta: { title: '用户管理', icon: 'user', noCache: false },
        component: _import('user_permissions/user'),
        menu: 'user'
      }
      optionChild = option
      break
    case 'organization':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'organization',
        name: 'Organization',
        meta: { title: '组织管理', icon: 'orangnization', noCache: false },
        component: _import('user_permissions/organization'),
        menu: 'organization'
      }
      optionChild = option
      break
    case 'role':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'role',
        name: 'Role',
        meta: { title: '角色管理', icon: 'role', noCache: false },
        component: _import('user_permissions/role'),
        menu: 'role'
      }
      optionChild = option
      break
    case 'function':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'function',
        name: 'Function',
        meta: { title: '功能管理', icon: 'function', noCache: false },
        component: _import('user_permissions/function'),
        menu: 'function'
      }
      optionChild = option
      break
    case 'video':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'video',
        name: 'Video',
        meta: { title: '培训视频', icon: 'video', noCache: false },
        component: _import('exam/video'),
        menu: 'video'
      }
      optionChild = option
      break
    case 'online_examination':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'online_examination',
        name: 'OnlineExamination',
        meta: { title: '在线考试', icon: 'online_examination', noCache: false },
        component: _import('exam/online_examination'),
        menu: 'online_examination'
      }
      optionChild = option
      break
    case 'examination_record':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'examination_record',
        name: 'ExaminationRecord',
        meta: { title: '考试记录', icon: 'examination_record', noCache: false },
        component: _import('exam/examination_record'),
        menu: 'examination_record'
      }
      optionChild = option
      break
    case 'certificate':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'certificate',
        name: 'Certificate',
        meta: { title: '证书信息', icon: 'certificate', noCache: false },
        component: _import('exam/certificate'),
        menu: 'certificate'
      }
      optionChild = option
      break
    case 'certificate_statistics':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'certificate_statistics',
        name: 'CertificateStatistics',
        meta: { title: '证书统计', icon: 'certificate', noCache: false },
        component: _import('exam/certificate_statistics'),
        menu: 'certificate_statistics'
      }
      optionChild = option
      break
    case 'notice_management':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'notice_management',
        name: 'NoticeManagement',
        meta: { title: '公告管理', icon: 'notice_management', noCache: false },
        component: _import('exam/notice_management'),
        menu: 'notice_management'
      }
      optionChild = option
      break
    case 'video_management':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'video_management',
        name: 'VideoManagement',
        meta: { title: '培训视频管理', icon: 'video_management', noCache: false },
        component: _import('exam/video_management'),
        menu: 'video_management'
      }
      optionChild = option
      break
    case 'label_management':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'label_management',
        name: 'LabelManagement',
        meta: { title: '视频标签管理', icon: 'label_management', noCache: false },
        component: _import('exam/label_management'),
        menu: 'label_management'
      }
      optionChild = option
      break

    case 'single':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'single',
        name: 'Single',
        meta: { title: '单选题库管理', icon: 'single', noCache: false },
        component: _import('exam/question_bank_management/single'),
        menu: 'single'
      }
      optionChild = option
      break
    case 'multiple':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'multiple',
        name: 'Multiple',
        meta: { title: '多选题库管理', icon: 'multiple', noCache: false },
        component: _import('exam/question_bank_management/multiple'),
        menu: 'multiple'
      }
      optionChild = option
      break
    case 'judge':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'judge',
        name: 'Judge',
        meta: { title: '判断题库管理', icon: 'judge', noCache: false },
        component: _import('exam/question_bank_management/judge'),
        menu: 'judge'
      }
      optionChild = option
      break
  }
}
function delteFakeParent(router) {
  for (let i = 0; i < router.length; i++) { // 一级遍历
    if (router[i].children.length) { // 如果一级下还有二级
      for (let j = 0; j < router[i].children.length; j++) { // 二级遍历
        if (router[i].children[j].children && router[i].children[j].children.length) {
          router[i].children[j].children.forEach(val => {
            router[i].children.push(val)
          })
          router[i].children.splice(j, 1)
          j--
        }
      }
    }
  }
  return router
}
export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js